export const REACT_APP_CONFIG_CAT_KEY = 'REACT_APP_CONFIG_CAT_KEY';

export const FeatureFlags = {
  CALC_TRACE_ENABLED: 'isCalculationTraceEnabled',
};

export const ConfigCatLocalOverrides = {
  [FeatureFlags.CALC_TRACE_ENABLED]: false,
};
